import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// fetch("/config.json")
//   .then((res) => res.json())
//   .then((config) => {
//     // Save config to global variable or context
//     window.RUNTIME_CONFIG = config;
//   });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);


// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import 'bootstrap/dist/css/bootstrap.min.css';
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

// fetch("/config.json")
//   .then((res) => res.json())
//   .then((config) => {
//     // Save config to global variable
//     window.RUNTIME_CONFIG = config;

//     // Now render the app
//     const root = ReactDOM.createRoot(document.getElementById("root"));
//     root.render(<App />);
//   })
//   .catch((err) => {
//     console.error("Failed to load config.json", err);
    
//     // Optional: Show fallback error UI
//     const root = ReactDOM.createRoot(document.getElementById("root"));
//     root.render(<div>Failed to load configuration. Please try again later.</div>);
//   });
